import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    block: {
        backgroundColor: theme.palette.secondary.main,
        border: "1px solid "+theme.palette.secondary.border,
        display: "flex",
        alignItems: "center",
        width: "100%",
    },
}));


export default function Block({ children, padding = "1rem 2rem", style = {}, className = '', elementType = "div", ...props }) {

    const classes = useStyles();

    const blockProps = {
        ...props,
        style: {
            padding: padding,
            ...style
        },
        className: classes.block + " block " + className,
    }

    // the variable has to be capitalised to work in JSX
    const ElementType = elementType;

    return (
        <ElementType {...blockProps}>
            <div className="block__inner">
                {children}
            </div>
        </ElementType>
    );
}